<form>
  <div class="form-fields">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Cohort Name</mat-label>
      <input matInput class="form-control-textbox" [(ngModel)]="llttfinvitation.cohortName" name="cohortname" />
    </mat-form-field>
    @if (isSubmitted && (llttfinvitation.cohortName === '')) {
      <mat-error class="validation-error">Cohort Name is
      required</mat-error>
    }
  </div>
  <div class="mb-10"></div>

  <div class="form-fields">
    <mat-form-field>
      <mat-label>Program</mat-label>
      <mat-select placeholder="Select" name="program" [(ngModel)]="llttfinvitation.programId">
        @for (prog of programs; track prog) {
          <mat-option [value]="prog.id">
            {{ prog.programName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (isSubmitted && llttfinvitation.programId==0) {
      <mat-error class="validation-error">Program is
      required</mat-error>
    }
  </div>
  <div class="mb-10"></div>

  <div class="form-fields">
    <mat-form-field>
      <mat-label>Organization</mat-label>
      <mat-select placeholder="Select" name="org" [(ngModel)]="llttfinvitation.organizationId" (ngModelChange)="bindFacilitator()" [disabled]="llttfinvitation.isLoggedInUserFacilitator">
        @for (org of organizations; track org) {
          <mat-option [value]="org.id" >
            {{ org.organizationName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (isSubmitted && !llttfinvitation.organizationId) {
      <mat-error class="validation-error">Organization is
      required</mat-error>
    }
  </div>
  <div class="mb-10"></div>

  <div class="form-fields">
    <mat-form-field>
      <mat-label>Facilitator</mat-label>
      <mat-select placeholder="Select" name="facilitator" [(ngModel)]="llttfinvitation.facilitatorId" [disabled]="llttfinvitation.isLoggedInUserFacilitator">
        @for (user of filteredFacilitator; track user) {
          <mat-option [value]="user.userDbId">
            {{ user.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (isSubmitted && llttfinvitation.facilitatorId==0 || llttfinvitation.facilitatorId==null) {
      <mat-error class="validation-error">Facilitator is
      required</mat-error>
    }
  </div>
  <div class="mb-10"></div>

  <div class="form-fields">
    <mat-form-field>
      <mat-label>Language</mat-label>
      <mat-select name="language" [(ngModel)]="llttfinvitation.languageId">
        <mat-option [value]="1">English</mat-option>
        <mat-option [value]="2">Français</mat-option>
      </mat-select>
    </mat-form-field>
    @if (isSubmitted && (llttfinvitation.languageId == null || llttfinvitation.languageId == 0)) {
      <mat-error class="validation-error">Language is required</mat-error>
    }
  </div>
  <div class="mb-10"></div>

  <div class="form-fields">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label># of Participants</mat-label>
      <input matInput class="form-control-textbox" [(ngModel)]="llttfinvitation.noOfParticipants"
        name="numparticipants" />
      </mat-form-field>
      @if (isSubmitted && (llttfinvitation.noOfParticipants === 0||llttfinvitation.noOfParticipants === null)) {
        <mat-error class="validation-error"
          >Number
        of Participants is required</mat-error>
      }
    </div>
    <div class="mb-10"></div>

    <div class="form-fields">
      <mat-form-field appearance="outline" floatLabel="always" class="w-10p0">
        <mat-label>Expected Program Start Date</mat-label>
        <input matInput [matDatepicker]="dp4" [(ngModel)]="llttfinvitation.programStartDate" name="programstartdate"
          placeholder="DD/MM/YYYY" required>

          <mat-datepicker-toggle matIconSuffix [for]="dp4"></mat-datepicker-toggle>
          <mat-datepicker #dp4></mat-datepicker>
        </mat-form-field>
        @if (isSubmitted && llttfinvitation.programStartDate == null) {
          <mat-error class="validation-error">Start Date
          is required</mat-error>
        }
      </div>

      <div class="mb-10"></div>

      <div class="form-fields">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Link Expiry Date</mat-label>
          <input matInput [matDatepicker]="dp5" [(ngModel)]="llttfinvitation.linkExpiryDate" name="linkexpirydate"
            placeholder="DD/MM/YYYY" required>

            <mat-datepicker-toggle matIconSuffix [for]="dp5"></mat-datepicker-toggle>
            <mat-datepicker #dp5></mat-datepicker>
          </mat-form-field>
          @if (isSubmitted && llttfinvitation.linkExpiryDate == null) {
            <mat-error class="validation-error">Expiry Date is
            required</mat-error>
          }
          @if (isSubmitted && !chkLinkExpiryDate()) {
            <mat-error class="validation-error">Expiry Date should be greater
            than today and program start date.</mat-error>
          }
        </div>

        <div class="mb-10"></div>
        <div>
          Status
          <div class="toggle">
            <div class="switch-div">
              <input type="radio" name="sizeBy" [value]="true" id="active" class="active"
                [(ngModel)]="llttfinvitation.isActive" (ngModelChange)="radiochange()" />
                <label for="active">Active</label>
              </div>
              <div class="switch-div">
                <input type="radio" name="sizeBy" [value]="false" id="inactive" class="inactive"
                  [(ngModel)]="llttfinvitation.isActive" />
                  <label for="inactive">Withdrawn</label>
                </div>
              </div>
            </div>
            <div class="mb-10"></div>
          </form>
          <div class="mb-10"></div>
